import { createEvent } from "./auth-service-tools655.js";

function fireEvent(element, type, eventInit) {
  return element.dispatchEvent(createEvent(element, type, eventInit));
}

export { fireEvent };